import React from "react";
import './Header.css'
import html2canvas from 'html2canvas';

const Header = () => {
    return (
      <header>
        <div className = "head-text">
            <div className="button-area" id="button-area">
                <button id="input-button" onClick={onInputButtonClick}>input your text</button>
                <button id="shot-button" onClick={screenShot}>screen shot</button>
            </div>
            <div className = "head-image">
                <img src = {require ('./images/test.png')} alt = "Blog" width={"100%"} />
            </div>
            <div className="input-text" id="input-text">
                <textarea rows={5} cols={33} id="text-area"></textarea>
            </div>
            <div className="text-on-image" id="text-on-image">
                <h3 id="text-on-image-h3"> 人世间 </h3>
            </div>
        </div>
      </header>
    )
  }

function $(str)
{
    return document.getElementById(str);
}

function onInputButtonClick()
{
    let buttonText = $('input-button').innerHTML;
    if( buttonText === "input your text" )
    {
        $('input-button').innerHTML = "put on image";
        $('input-text').style.display = "block";
    }
    else if( buttonText === "put on image" )
    {
        $('input-button').innerHTML = "input your text";
        $('input-text').style.display = "none";
        let inputStr = $('text-area').value;
        console.log( inputStr );
        let result = inputStr.replace(/\n/g, "<br>");
        $('text-on-image-h3').innerHTML = result;
        console.log( $('text-on-image-h3') );
    }
}

function screenShot()
{
    $('button-area').style.display = "none";
    $('visitCount').style.display = "none";
    $('input-text').style.display = "none";
    const screenshotTarget = document.body;

    html2canvas(screenshotTarget).then((canvas) => {
        const link = document.createElement('a');
        document.body.append( link );
        link.style.display = 'none';
        link.setAttribute('download', 'MintyPaper.png');
        link.setAttribute('href', canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
        link.click();
        document.body.removeChild(link);
        $('button-area').style.display = "block";
        $('visitCount').style.display = "block";
    });    
}

export default Header;